import React from "react";
import { Box, Card, CardContent, Chip, Typography } from "@mui/material";
import chroma from "chroma-js";
import ReactAudioPlayer from "react-audio-player";
import { useSelector } from "react-redux";
import { shortenString } from "../../../Constant/helper";
import StatusButton from "../Common/Buttons/StatusButton";
import EmptyState from "../Common/EmptyState";

const PatientHistoryBody = ({ callHistoryData }) => {
  const reducer: any = useSelector((state) => state);
  const {
    AccountReducer: { constantData },
  } = reducer;

  return (
    <>
      <Box display="flex" flexDirection="column" gap={2}>
        {callHistoryData?.length > 0 ? (
          callHistoryData?.map((item, index) => {
            const status = constantData["callStatus"][item?.callStatus];
            let statusColor =
              constantData["callStatusColour"][item?.callStatus] || "#333333";

            try {
              statusColor = chroma(statusColor).hex();
            } catch (error) {
              statusColor = "#333333";
            }
            const backgroundColor = chroma(statusColor).alpha(0.1).hex();

            return (
              <Card key={index} variant="outlined" sx={{ borderRadius: 2 }}>
                <CardContent>
                  {item.status && (
                    <Chip
                      label={`📞 Status: ${item.status}`}
                      color="primary"
                      variant="outlined"
                    />
                  )}

                  {item.call_uuid && (
                    <Typography variant="body2" gutterBottom>
                      <strong>Call UUID:</strong> {item.call_uuid}
                    </Typography>
                  )}

                  {item.projectId && (
                    <Typography variant="body2" gutterBottom>
                      <strong>Project ID:</strong> {item.projectId}
                    </Typography>
                  )}
                  {item.campaignRunId && (
                    <Typography variant="body2">
                      <strong>Campaign Run ID:</strong> {item.campaignRunId}
                    </Typography>
                  )}
                  {item.callStatus && (
                    <Box className="flex-align-center gap-2 my-2">
                      <Typography variant="body2">
                        <strong>Call Status:</strong>
                      </Typography>
                      <Box>
                        <StatusButton
                          status={status || item?.callStatus}
                          statusColor={statusColor}
                          backgroundColor={backgroundColor}
                        />
                      </Box>
                    </Box>
                  )}

                  {item.callRecordingUrl && (
                    <Box className="flex-align-center gap-2 my-2">
                      <Typography variant="body2" gutterBottom>
                        <strong>Recording:</strong>
                      </Typography>
                      <Box>
                        <ReactAudioPlayer
                          src={item?.callRecordingUrl}
                          controls
                          style={{
                            minWidth: "40px",
                            height: "30px",
                          }}
                        />
                      </Box>
                    </Box>
                  )}

                  {item.summary && (
                    <Typography variant="body2">
                      <strong>Summary:</strong>{" "}
                      {shortenString(item.summary, 350)}
                    </Typography>
                  )}
                </CardContent>
              </Card>
            );
          })
        ) : (
          <EmptyState message="No Call History Available" />
        )}
      </Box>
    </>
  );
};

export default PatientHistoryBody;
